import { useMemo } from 'react'
import { ToolInvocationUIPart } from 'ai'
import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

const ArticleGenerationMessage = ({
  part,
  icon,
}: {
  part: ToolInvocationUIPart

  icon: React.ReactNode
}) => {
  // Improved completion check - if we have a result, we're done
  /* FIXME(@ai-sdk-upgrade-v5): The `part.toolInvocation.state` property has been removed. Please manually migrate following https://ai-sdk.dev/docs/migration-guides/migration-guide-5-0#tool-part-type-changes-uimessage */
  const isActuallyCompleted =
    part.toolInvocation.state === 'result' ||
    ((part.toolInvocation as any).result !== undefined &&
      (part.toolInvocation as any).result !== null)

  const loadingContent = useMemo(() => {
    return (
      <div className='flex items-center justify-start gap-2'>
        <span>Generating document...</span>
        <Loader2 className='size-4 animate-spin' />
      </div>
    )
  }, [])
  // console.log('>>> article generation', part, doc)
  return (
    <div className='flex w-full flex-col items-start gap-0'>
      <div className='group/icon inline-flex h-auto w-full min-w-16 items-center justify-start gap-2 bg-transparent px-3 py-2.5 hover:bg-transparent'>
        <div className='text-muted-foreground flex w-4 shrink-0 items-center justify-center'>
          <div>{icon}</div>
        </div>

        <span
          className={cn(
            'text-foreground flex-1 text-left text-[14px] leading-5 font-medium tracking-[0] break-words whitespace-normal'
          )}
        >
          {isActuallyCompleted ? 'Generated document' : loadingContent}
        </span>
      </div>
    </div>
  )
}

export default ArticleGenerationMessage
